export const messages = {
  en: {
    deleteMerchant: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteMerchant: 'Confirm to delete merchant?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete'
    }
  },
  zh: {
    deleteMerchant: {
      confirmOperation: '请确认您的操作',
      confirmDeleteMerchant: '确定删除商家',
      cancel: '点错了',
      confirmDelete: '确认删除'
    }
  }
}